module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "lofigs"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0006#toc"
    }
  }, [_vm._v("FIGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0011#fig1"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.")])]), _vm._v(" Anna Magdalena Bach, title page of Notebook of 1722. D-B Mus. ms. Bach P 224. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0011#fig2"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.")])]), _vm._v(" Front cover of Notebook of 1725. D-B Mus. ms. Bach P 225. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0011#fig3"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.")])]), _vm._v(" Georg Heinrich Ludwig Schwanberg, title page of J. S. Bach, "), _c('i', [_vm._v("Works for Solo Violin")]), _vm._v(" (BWV 1001–7). D-B Mus. ms. Bach P 268. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0011#fig4"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.")])]), _vm._v(" Anna Magdalena Bach’s inscription in her personal copy of Johann Jacob Rambach, "), _c('i', [_vm._v("Betrachtungen über das gantze Leiden Christi")]), _vm._v(" (Jena: Hartung, 1732). Courtesy of Bach-Archiv, Leipzig, shelfmark Rara I, 2.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0012#fig0101"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.1.")])]), _vm._v(" Kurt Arnold Findeisen, “Das Notenbüchlein der Frau Anna Magdalena Bachin” (Leipzig: Kistner & Siegel, 1924), illustration by Erich Gruner.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0012#fig0102"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.2.")])]), _vm._v(" [Esther Meynell], "), _c('i', [_vm._v("Die kleine Chronik der Anna Magdalena Bach")]), _vm._v(" (Leipzig: Koehler & Amelang, 1930), dust jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0012#fig0103"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.3.")])]), _vm._v(" Martin Jarvis, "), _c('i', [_vm._v("Written by Mrs. Bach: The Amazing Discovery That Shocked the Music World")]), _vm._v(" (Sydney: ABC Books, 2011). Cover designed by Christa Moffitt. Courtesy of Getty Images and ABC Books.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0012#fig0104"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.4.")])]), _vm._v(" Digital edition of Esther Meynell, "), _c('i', [_vm._v("The Little Chronicle of Magdalena Bach")]), _vm._v(" (Endeavour Press, 2016). Courtesy of Endeavour Press.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#fig0201"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.1.")])]), _vm._v(" “Ihr Diener werthe Jungfer Braut,” written out by Anna Magdalena and Johann Sebastian Bach. D-B Mus. ms. Bach P 225 [p. 122]. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#fig0202"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.2.")])]), _vm._v(" Sperontes [Johann Sigismond Scholze], "), _c('i', [_vm._v("Singende Muse an der Pleiße")]), _vm._v(" (Leipzig: Lustige Gesellschafft, 1736), frontispiece, engraved by C. F. Boetius.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#fig0203"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.3.")])]), _vm._v(" Johann Joachim Kändler, "), _c('i', [_vm._v("Faustina Bordoni and Fox")]), _vm._v(". Meissen, c. 1743. Metropolitan Museum of Art, accession no. 64.101.125.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#fig0204"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.4.")])]), _vm._v(" Jacob Matham, "), _c('i', [_vm._v("Unequal Pair with Fool")]), _vm._v(", after 1597. Courtesy of bpk Bildagentur and Staatliche Kunstsammlung Dresden, inventory no. C 1962–107.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#fig0301"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.1.")])]), _vm._v(" “So oft ich meine Tobacks Pfeife” (BWV 515a), written out by Anna Magdalena and Johann Sebastian Bach. D-B Mus. ms. Bach P 225 [p. 69]. Courtesy Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0015#fig0401"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.1.")])]), _vm._v(" J. S. Bach, "), _c('i', [_vm._v("Fantasia pro Organo")]), _vm._v(" (BWV 573). D-B Mus. ms. Bach P 224 [p. 40]. Courtesy of Staatsbibliothek zu Berlin, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxi"
    }
  }), _vm._v("Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0015#fig0402"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.2.")])]), _vm._v(" Arnolt Schlick, "), _c('i', [_vm._v("Spiegel der Orgelmacher und Organisten")]), _vm._v(" (Mainz: Peter Schöffer, 1511), reprint of title page (Berlin: Puta, 1869). Courtesy of Division of Rare and Manuscript Collections, Carl A. Kroch Library, Cornell University, shelfmark arW3202.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0015#fig0403"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.3.")])]), _vm._v(" Anonymous, "), _c('i', [_vm._v("Portrait of Barbara Kluntz")]), _vm._v(", c. 1720. © Museum Ulm, photographer Ingeborg Schmatz, Ulm. Inventory no. 1928.6048.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0015#fig0404"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.4.")])]), _vm._v(" Johann Kuhnau, "), _c('i', [_vm._v("Musicalische Vorstellung einiger biblischer Historien")]), _vm._v(" (Leipzig: Tietzen, 1700), frontispiece.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0015#fig0405"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.5.")])]), _vm._v(" J. S. Bach, Organ Sonata in E Minor (BWV 528), mvt. 1: first page [p. 36] in hand of Wilhelm Friedemann Bach, facing page [p. 37] in hand of Anna Magdalena Bach, D-B Mus. ms. Bach P 272. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#fig0501"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.1.")])]), _vm._v(" “Sängerin,” Johann Christoph Weigel, "), _c('i', [_vm._v("Musicalisches Theatrum")]), _vm._v(" (Nuremberg: Weigel, c. 1720).")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#fig0502"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.2.")])]), _vm._v(" “Leyerin,” Johann Christoph Weigel, "), _c('i', [_vm._v("Musicalisches Theatrum")]), _vm._v(" (Nuremberg: Weigel, c. 1720).")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#fig0503"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.3.")])]), _vm._v(" Johann Heinrich Tischbein the Elder, "), _c('i', [_vm._v("Self-Portrait with First Wife at Clavichord")]), _vm._v(", c. 1756. Courtesy of Gemäldegalerie Berlin, bpk Bildagentur (photo: Jörg P. Anders) and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#fig0601"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.1.")])]), _vm._v(" Gottfried Balthasar Scharff, "), _c('i', [_vm._v("Gottseliger Wittwen Bibliothek")]), _vm._v(" (Leipzig: Knoche, 1724), frontispiece to part 1. Courtesy of the Württembergische Landesbibliothek, Stuttgart, shelfmark Theol.oct.15611.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#fig0602"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.2.")])]), _vm._v(" Gottfried Balthasar Scharff, "), _c('i', [_vm._v("Gottseliger Wittwen Bibliothek")]), _vm._v(" (Leipzig, 1724), frontispiece to part 3. Courtesy of the Württembergische Landesbibliothek, Stuttgart, shelfmark Theol.oct.15611.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#fig0603"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.3.")])]), _vm._v(" J. S. Bach, "), _c('i', [_vm._v("Jesus, meine Zuversicht")]), _vm._v(" (BWV 728). D-B Mus. ms. Bach P 224 [p. 45]. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, New York.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#fig0604"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.4.")])]), _vm._v(" J. S. Bach, "), _c('i', [_vm._v("O Ewigkeit, du Donnerwort")]), _vm._v(" (BWV 513). D-B Mus. ms. Bach P 225 [p. 21]. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#fig0605"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.5.")])]), _vm._v(" J. S. Bach, "), _c('i', [_vm._v("Wer nur den lieben Gott läßt walten")]), _vm._v(" (BWV 691). D-B Mus. ms. Bach P 225 [p. 55]. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, NY.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0018#fig0701"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("7.1.")])]), _vm._v(" [Christian Pezold], Minuet in G (BWV Anh. 114). D-B Mus. ms. Bach P 225 [p. 44]. Courtesy of Staatsbibliothek zu Berlin, Preußischer Kulturbesitz, Musikabteilung mit Mendelssohn-Archiv, bpk Bildagentur and Art Resource, New York.")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0018#fig0702"
    }
  }, [_vm._v("FIGURE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("7.2.")])]), _vm._v(" The Toys sing “A Lover’s Concerto” on the television program "), _c('i', [_vm._v("Hullabaloo")]), _vm._v(", October 25, 1965.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a149f00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-yearsley-0008.vue
// module id = 75
// module chunks = 0